module.exports = __webpack_public_path__ + "static/img/headerBox.0c3f3acc.png";